/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/recent-activity.js';
import DateHelper from '../classes/date.js';

class RecentActivityStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.dashboard = [];
    }

    _registerToActions(action) {


        switch(action.actionType)
        {
            case Constants.UPDATE_DASHBOARD_ACTIVITY:
                this.dashboard = action.response;
                break;
        }

        this.emitChange();
    }

    getDashboard(){
        return this.dashboard;
    }

}

export default new RecentActivityStore();


// WEBPACK FOOTER //
// ./src/store/recent-activity-store.js